<template>
    <div class="modal fade Betamount" id="userid_Modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>{{$t('user-id', 'User ID')}}</h5>
                    <button type="button" class="btn-close" aria-label="Close" @click="closeUserId($auth?.user?.userid)"></button>
                </div>
                <div class="modal-body">
                    <div class="userid-celebration-img">
                        <img src="@/assets/images/user-id.webp" alt="user-id">
                    </div>
                    <div class="modal-userid-sec">
                        <div class="c_text">
                            <div class="flex_between copy-user-text-sec">
                                <h5 class="payment_op">{{ $auth?.user?.userid }}</h5>
                                <button class="copy_btn" @click="copyRefUrl($auth?.user?.userid)" type="button">
                                    <!-- <img src="@/assets/images/c_text.svg" alt="copy" /> -->
                                    Copy
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'UserIdModal',
    computed: {
        ...mapGetters(['logInData']),
        lastLogIn() {
            return this.$store.getters.stateUser?.last_login_at
        },
    },
    methods: {
        copyRefUrl(referData) {
            if (navigator.clipboard && window.isSecureContext) {
                // Preferred method
                navigator.clipboard.writeText(referData)
                    .then(() => {
                        this.$successToast("Successfully copied.");
                    })
                    .catch(err => {
                        console.error("Failed to copy: ", err);
                    });
            } else {
                // Fallback for older browsers
                let input = document.createElement("textarea");
                input.value = referData;
                document.body.appendChild(input);
                input.select();
                document.execCommand("copy");
                this.$successToast("Successfully copied.");
            }
        },
        closeUserId(userId) {
            let newUserIdsList = this.logInData?.userIds || [];
            newUserIdsList.push(userId)
            let data = {
                "logInWithMobile": true,
                "userIds": newUserIdsList
            }
            this.$store.dispatch('setLogInData', data);
            this.$helper.closeModal("userid_Modal");
            if(this.$siteSettings?.data.offer?.image) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$helper.openModal("#offer_pop_up");
                    }, 500)
                })
            }
            
            
        }
        
    }
}
</script>

<style></style>